import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../../FJModal';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionModal from '../../../../redux/action/FJActionModal';
import { useCallback } from 'react';
import FJRecordModal from '../view/FJRecordModal.jsx';
import FJActionRecord from '../../../../redux/action/FJActionRecord.js';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJActionVoiceCloning from '../../../../redux/action/FJActionVoiceCloning.js';

const FJRecordModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const isShowRecordDisplay = useSelector(state => state.modals.isShowRecordDisplay);

    const recorderDeviceList = useSelector(state => state.record.recorderDeviceList);
    const recorderDeviceId = useSelector(state => state.record.recorderDeviceId);
    const recorderDuration = useSelector(state => state.record.recorderDuration);
    const recordStatus = useSelector(state => state.record.recordStatus);
    const audioUrl = useSelector(state => state.record.audioUrl);
    const audioName = useSelector(state => state.record.audioName);

    const onClose = useCallback(() => {
        dispatch(FJActionModal.hideRecordModalAction());
    }, [dispatch]);

    const onDeviceIdChange = id => {
        dispatch(FJActionRecord.setRecorderDeviceIdAction(id));
    };

    const startRecord = container => {
        dispatch(FJActionRecord.startRecorderAction(container));
    };
    const onClickRecorder = () => {
        dispatch(FJActionRecord.setIsShowRecorderDelayAction(true));
    };

    const onRetry = () => {
        dispatch(FJActionRecord.stopRecorderAction(true));
        if (recorderDeviceList.length === 0) {
            dispatch(FJActionRecord.setRecordStatusAction(FJConstant.NO_PERMISSION));
        } else {
            dispatch(FJActionRecord.setRecordStatusAction(FJConstant.DEFAULT));
        }
    };

    const onStop = () => {
        dispatch(FJActionRecord.stopRecorderAction());
    };

    const useRecord = () => {
        const recordVoiceType = FJUtil.getRecordVoiceType();
        switch (recordVoiceType) {
            case FJConstant.RECORD_IN_CREATE_CLONE:
                dispatch(FJActionVoiceCloning.applyRecordAction());
                break;
            default:
                dispatch(FJActionAIAudioGenerator.applyRecordAction());
        }
    };

    return (
        <FJModal visible={isShowRecordDisplay} zIndex={1001}>
            <FJRecordModal
                onClose={onClose}
                recorderDeviceList={recorderDeviceList}
                recorderDeviceId={recorderDeviceId}
                recorderDuration={recorderDuration}
                recordStatus={recordStatus}
                onDeviceIdChange={onDeviceIdChange}
                onClickRecorder={onClickRecorder}
                onRetry={onRetry}
                onStop={onStop}
                startRecord={startRecord}
                audioUrl={audioUrl}
                audioName={audioName}
                useRecord={useRecord}
            />
        </FJModal>
    );
};
export default FJRecordModalContainer;
